<template>
  <a-modal :title="form.id ? '修改客服信息' : '新增客服信息'" :visible="visible" :confirm-loading="confirmLoading" @ok="handleOk"
    @cancel="handleCancel" destroyOnClose :maskClosable="false" width="900px">
    <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-row>
        <a-col :span="24">
          <a-row>
            <a-col :span="12">
              <a-form-model-item label="标题" prop="title">
                <a-input v-model="form.title" placeholder="请输入标题" />
              </a-form-model-item>
              <a-form-model-item label="描述" prop="dec">
                <a-textarea v-model="form.dec" placeholder="请输入描述" :rows="4" />
              </a-form-model-item>
              <a-form-model-item label="分享logo" prop="link_logo" required>
                <a-upload name="file" list-type="picture-card" :multiple="false" :action="baseURL + '/admin/sys/upload'"
                  :remove="removeLinkLogo" @change="handleLinkLogoChange" @preview="preview" :show-upload-list="false"
                  :headers="{
                    Authorization: `Bearer ${token}`,
                  }">
                  <img v-if="form.link_logo" :src="form.link_logo" alt="avatar" width="100px" />
                  <div v-else>
                    <a-icon :type="loadingLinkLogo ? 'loading' : 'plus'" />
                    <div class="ant-upload-text">Upload</div>
                  </div>
                  <div class="ant-upload-text" v-if="!!form.link_logo" @click.stop="removeLinkLogo()">点击删除</div>
                </a-upload>
              </a-form-model-item>
              <a-form-model-item label="是否可用" prop="status" required>
                <a-radio-group v-model="form.status">
                  <a-radio value="1">可用</a-radio>
                  <a-radio value="2">不可用</a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="中转页面图片" prop="mid_img" required>
                <a-upload name="file" list-type="picture-card" :multiple="false" :action="baseURL + '/admin/sys/upload'"
                  :remove="removeMidImg" @change="handleMidImgChange" @preview="preview" :show-upload-list="false"
                  :headers="{
                    Authorization: `Bearer ${token}`,
                  }">
                  <img v-if="form.mid_img" :src="form.mid_img" alt="avatar" width="100px" />
                  <div v-else>
                    <a-icon :type="loadingMidImg ? 'loading' : 'plus'" />
                    <div class="ant-upload-text">Upload</div>
                  </div>
                  <div class="ant-upload-text" v-if="!!form.mid_img" @click.stop="removeMidImg()">点击删除</div>
                </a-upload>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-col>
        <a-col :span="24">
          <a-alert message="以下是小程序板块管理的内容" description="" type="info" show-icon></a-alert>
          <br>
          <a-row>
            <a-col :span="24">
              <a-form-model-item label="小程序页面标题" prop="mini_title">
                <a-input v-model="form.mini_title" placeholder="小程序页面标题" />
              </a-form-model-item>
            </a-col>
              <a-col :span="24">
              <a-form-model-item label="客服图片" prop="kefu_img" required>
                <a-upload name="file" list-type="picture-card" :multiple="false" :action="baseURL + '/admin/sys/upload'"
                  :remove="removeKefuImg" @change="handleKefuImgChange" @preview="preview" :show-upload-list="false"
                  :headers="{
                    Authorization: `Bearer ${token}`,
                  }">
                  <img v-if="form.kefu_img" :src="form.kefu_img" alt="avatar" width="100px" />
                  <div v-else>
                    <a-icon :type="loadingKefuImg ? 'loading' : 'plus'" />
                    <div class="ant-upload-text">Upload</div>
                  </div>
                  <div class="ant-upload-text" v-if="!!form.kefu_img" @click.stop="removeKefuImg()">点击删除</div>
                </a-upload>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item label="小程序页面底部提示" prop="mini_msg">
                <a-textarea v-model="form.mini_msg" placeholder="小程序页面底部提示" :rows="3" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
import { baseURL } from "@/api/index";
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["token"]),
  },
  data() {
    return {
      baseURL,
      visible: false,
      confirmLoading: false,
      loadingMidImg: false,
      loadingKefuImg: false,
      loadingLinkLogo: false,
      form: {
        id: "",
        title: "",
        dec: "",
        link_logo: "",
        mid_img: "",
        kefu_img: "",
        status: "1",
        mini_title: "",
        mini_msg: "",
      },
      rules: {
        title: [
          {
            required: true,
            message: "请输入标题",
            trigger: "blur",
          },
        ],
        dec: [
          {
            required: true,
            message: "请输入描述",
            trigger: "blur",
          },
        ],
        status: [
          {
            required: true,
            message: "请选择是否可用",
            trigger: "change",
          },
        ],
        mid_img: [
          {
            required: true,
            message: "请上传中转页面图片",
            trigger: "change",
          },
        ],
        kefu_img: [
          {
            required: true,
            message: "请上传客服图片",
            trigger: "change",
          },
        ],
        link_logo: [
          {
            required: true,
            message: "请上传分享logo",
            trigger: "change",
          },
        ],
      },
      labelCol: { span: 7 },
      wrapperCol: { span: 16 },
    };
  },
  methods: {
    init(id) {
      this.visible = true;
      this.form.id = id;
      if (id) {
        this.$http({
          url: "/admin/kefu/info",
          method: "post",
          data: {
            id: id,
          },
        }).then((res) => {
          this.form = {
            ...res.data,
            status: res.data.status || "1",
          };
        });
      } else {
        // 重置表单
        this.form = {
          id: "",
          title: "",
          dec: "",
          link_logo: "",
          mid_img: "",
          kefu_img: "",
          status: "1",
          mini_title: "",
          mini_msg: "",
        };
      }
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          this.$http({
            url: this.form.id
              ? "/admin/kefu/update"
              : "/admin/kefu/create",
            method: "post",
            data: {
              ...this.form,
            },
          })
            .then(() => {
              this.$message.success(
                this.form.id ? "修改成功" : "创建成功"
              );
              this.handleCancel();
              this.$emit("ok");
            })
            .catch(() => {
              this.confirmLoading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleCancel() {
      this.visible = false;
      this.confirmLoading = false;
      this.$refs["ruleForm"].resetFields();
    },
    removeMidImg() {
      this.form.mid_img = "";
      this.$nextTick(() => {
        this.$refs.ruleForm.validateField('mid_img');
      });
    },
    removeKefuImg() {
      this.form.kefu_img = "";
      this.$nextTick(() => {
        this.$refs.ruleForm.validateField('kefu_img');
      });
    },
    removeLinkLogo() {
      this.form.link_logo = "";
      this.$nextTick(() => {
        this.$refs.ruleForm.validateField('link_logo');
      });
    },
    handleMidImgChange(info) {
      if (info.file.status === "uploading") {
        this.loadingMidImg = true;
        return;
      }
      if (info.file.status === "done") {
        this.loadingMidImg = false;
        this.form.mid_img = info.file.response.data.url;
        this.$nextTick(() => {
          this.$refs.ruleForm.validateField('mid_img');
        });
      }
      if (info.file.status === "error") {
        this.loadingMidImg = false;
        this.$message.error("图片上传失败");
      }
    },
    handleKefuImgChange(info) {
      if (info.file.status === "uploading") {
        this.loadingKefuImg = true;
        return;
      }
      if (info.file.status === "done") {
        this.loadingKefuImg = false;
        this.form.kefu_img = info.file.response.data.url;
        this.$nextTick(() => {
          this.$refs.ruleForm.validateField('kefu_img');
        });
      }
      if (info.file.status === "error") {
        this.loadingKefuImg = false;
        this.$message.error("图片上传失败");
      }
    },
    handleLinkLogoChange(info) {
      if (info.file.status === "uploading") {
        this.loadingLinkLogo = true;
        return;
      }
      if (info.file.status === "done") {
        this.loadingLinkLogo = false;
        this.form.link_logo = info.file.response.data.url;
        this.$nextTick(() => {
          this.$refs.ruleForm.validateField('link_logo');
        });
      }
      if (info.file.status === "error") {
        this.loadingLinkLogo = false;
        this.$message.error("图片上传失败");
      }
    },
    preview(e) {
      const url = e.response ? e.response.url : e;
      this.$viewerApi({
        images: [url],
      });
    },
  },
};
</script>
<style>
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>
